import { Box } from '@mui/material'
import dayjs from 'dayjs'
import { IncorrectIcon, CorrectIcon, ClockIcon } from 'src/v3/core/icons'
import { getProgressColor } from '../utils/helpers'

type AssignmentStatusIndicatorProps = {
  completionPercentage: number
  dueDate?: string | null
}

export default function AssignmentStatusIndicator({
  completionPercentage,
  dueDate,
}: AssignmentStatusIndicatorProps) {
  let isOverdue =
    dueDate &&
    dayjs(dueDate).isBefore(dayjs(), 'day') &&
    completionPercentage < 100
  let isCompleted = completionPercentage === 100
  let daysUntilDue = dueDate ? dayjs(dueDate).diff(dayjs(), 'days') : null
  let statusText = isCompleted
    ? ''
    : isOverdue
      ? `${Math.abs(daysUntilDue ?? 0)}d overdue`
      : daysUntilDue === 0
        ? 'Due today'
        : `${daysUntilDue}d left`

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
      {isOverdue ? (
        <IncorrectIcon color="error" />
      ) : isCompleted ? (
        <CorrectIcon color="success" />
      ) : (
        <ClockIcon
          color={getProgressColor(completionPercentage, Boolean(isOverdue))}
        />
      )}
      {dueDate && <span>{statusText}</span>}
    </Box>
  )
}
